// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__w3mUz","summary":"CartItem_summary__NtdLm","price":"CartItem_price__5Xj99","amount":"CartItem_amount__NGkRQ","actions":"CartItem_actions__YX8iL"};